import { HostRoute } from '../components/ProtectedRoute';

export default [HostRoute];
